import useSwingData from "./useSwingData";

export default useSwingData